import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState, useSetRecoilState } from "recoil";
import { BoardInfoState_CommentRegKey, DialogMessageState, IsBottomLoading, ToastMessageState } from "../../recoil/states";
import { asyncReqCommentList, CommentListActions } from "../../reducers/CommentListReducer";
import { CommentRegActions } from "../../reducers/CommentRegReducer";
import { asyncReqCommentRemove, CommentRemoveActions } from "../../reducers/CommentRemoveReducer";
import { AppDispatch, RootState } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";
import CommentReg from "./CommentReg";
import { asyncReqIsLogin } from "../../reducers/LoginBtnsReducer";

const CommentList = () => {

    const CommentListReducer_Result = useSelector((state: RootState) => state.CommentListReducer); // 댓글 표시 처리를 위한 state
    const { MEM_UDID } = useSelector((state: RootState) => state.LoginBtnsReducer.asyncIsLogin); // '로그인 / 로그아웃' 버튼 표시 처리를 위한 state
    const CommentRegReducer_Result = useSelector((state: RootState) => state.CommentRegReducer); // 댓글 등록 처리를 위한 state
    const CommentRemoveReducer_Result = useSelector((state: RootState) => state.CommentRemoveReducer); // 댓글 삭제 처리를 위한 state
    const setDialogMessageState = useSetRecoilState(DialogMessageState); // 다일얼로그 메세지 요청 정보를 갖는 state
    const setToastMessageState = useSetRecoilState(ToastMessageState); // 토스트 메세지 요청 정보를 갖는 state
    const setBoardInfoState_CommentRegKey = useSetRecoilState(BoardInfoState_CommentRegKey); // 댓글등록 UI 랜더링 처리를 위해 사용되는 state
    const [isBottomLoading, setIsBottomLoading] = useRecoilState(IsBottomLoading); // 바닥 로딩바 표시 처리를 위해 사용되는 state
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (CommentListReducer_Result.status !== "LOADING") {
            setIsBottomLoading(true); // 바닥 로딩바 표시 처리
        }
    }, [CommentListReducer_Result.status]);

    // 댓글 등록 or 삭제 후, 할당 받은 댓글 관련 데이터 (해당 댓글 위치로 자동 스크롤바 이동시켜주기 위한 용도)
    const regCommentData = useRef({
        comment_seq: '', // 댓글 고유번호
        is_reply: false, // 대댓글 여부(true / false)
        prev_top: -1 // 댓글 삭제 후, 저장된 이전 스크롤바 top 값
    });

    const [answerTargetSeq, setAnswerTargetSeq] = useState(""); // '답글등록' 클릭 대상 댓글 고유번호를 가지는 state

    /**
    * 특정 Element 가 현재 스크롤 위치에 보여지고 있는지 여부 판단
    * 
    * @param jqObj 이벤트 객체
    * @returns 표시 여부 (true / false)
    */
    const isInViewport = (jqObj: JQuery<HTMLElement>) => {
        var elementTop = jqObj.offset()?.top as number;
        var elementBottom = elementTop + (jqObj.outerHeight() as number);
        var viewportTop = $(window).scrollTop() as number;
        var viewportBottom = viewportTop + ($(window).height() as number);
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    useEffect(() => {

        if (CommentListReducer_Result.status === "LOADING") {
            // 댓글 목록 > 통신 중 일 경우
        }
        else if (CommentListReducer_Result.status === "FAIL") {
            // 댓글 목록 > 통신 실패된 경우

            const message = "댓글 목록 가져오기 실패, 통신 처리 중 알 수 없는 오류가 발생하였습니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
        }
        else if (CommentListReducer_Result.status === "COMPLETE") {
            // 댓글 목록 > 통신 성공된 경우

            if (CommentListReducer_Result.n4ErrorCode !== 0) {
                // 에러가 발생한 경우

                const message = CommentListReducer_Result.strErrorMessage;
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else {
                // 정상인 경우

                // 페이지 이동 처리된 경우
                if ((window as any).isPageMove) {
                    (window as any).isPageMove = false;
                    CommonUtil.scrollTo("#navCommentListRoot", 0, 0); // 댓글 상단 영역으로 스크롤바 자동 이동
                }

                const comment_seq = CommonUtil.getQuerystring("c_seq", "");
                if (comment_seq !== "") {
                    // 최신 댓글 영역을 클릭한 경우

                    const comment_root = $("#comment_root_" + comment_seq + " .cmt_contents");

                    if (comment_root.length === 0) {
                        // 댓글이 다른 페이지에 존재할 경우, 댓글목록 최상단으로 스크롤바 자동 이동
                        const top = $("#navCommentListRoot").offset()?.top;
                        if (top === undefined) return;
                        CommonUtil.scrollTo(top, -7, 0);
                    }
                    else {
                        // 해당 댓글 영역으로 스크롤바 자동 이동
                        setTimeout(() => {
                            const top = comment_root.offset()?.top;
                            if (top === undefined) return;
                            CommonUtil.scrollTo(top, -100, 0);

                            // 등록된 댓글 영역이 눈에 띄게 깜빡이는 하이라이트 효과 적용
                            let loopHighlight = 4;
                            const arrBackground = ["#ff8f54", comment_root.css("background")];
                            const intvHighlightId = setInterval(() => {
                                if (!isInViewport(comment_root)) return; // 특정 댓글 UI 영역이 현재 스크롤 위치에 보이는지 여부 판단
                                if (loopHighlight <= 0) {
                                    clearInterval(intvHighlightId);
                                    return;
                                }
                                comment_root.css("background", arrBackground[loopHighlight % 2]);
                                loopHighlight--;
                            }, 300);
                        }, $("#flowWrap").is(":visible") ? 500 : 0);
                    }

                    // 새로고침하거나, SNS 공유했을 때 댓글 영역으로 이동되지 않도록 댓글 고유번호 파라메터 제거
                    const board_seq = CommonUtil.getQuerystring("seq", "");
                    window.history.replaceState(null, "", "/board_info?seq=" + board_seq);
                }

                if (regCommentData.current.comment_seq !== "" || regCommentData.current.prev_top !== -1) {
                    // 댓글 등록 or 삭제가 처리된 경우

                    if (regCommentData.current.comment_seq !== "") {
                        // 댓글 등록이 처리된 경우
                        const comment_root = $("#comment_root_" + regCommentData.current.comment_seq);
                        if (comment_root.length === 0) {
                            CommonUtil.scrollTo("#navCommentListRoot", -7, 500); // 댓글이 다른 페이지에 존재할 경우, 댓글목록 최상단으로 스크롤바 자동 이동
                        }
                        else {
                            CommonUtil.scrollTo(comment_root, -300, 500); // 해당 댓글 영역으로 스크롤바 자동 이동

                            // 등록된 댓글 영역이 눈에 띄게 깜빡이는 하이라이트 효과 적용
                            let loopHighlight = 4;
                            const arrBackground = ["#ff8f54", comment_root.css("background")];
                            const intvHighlightId = setInterval(() => {
                                if (!isInViewport(comment_root)) return; // 특정 댓글 UI 영역이 현재 스크롤 위치에 보이는지 여부 판단
                                if (loopHighlight <= 0) {
                                    clearInterval(intvHighlightId);
                                    return;
                                }
                                comment_root.css("background", arrBackground[loopHighlight % 2]);
                                loopHighlight--;
                            }, 300);
                        }
                        $("[id^=txt_Reg_Comment_]").val(""); // 모든 댓글 등록 UI에 입력했던 내용 삭제
                        $("[id^=root_emoji_]").hide(); // 모든 이모지 영역 숨김
                        setAnswerTargetSeq(""); // 대댓글 등록 UI 숨김 처리
                    }
                    else if (regCommentData.current.prev_top !== -1) {
                        // 댓글 삭제가 처리된 경우

                        CommonUtil.scrollTo(regCommentData.current.prev_top, 0, 500); // 이전 top 영역으로 스크롤바 자동 이동
                    }

                    // 댓글 관련 데이터 초기화
                    regCommentData.current.comment_seq = ""; // 댓글 고유번호
                    regCommentData.current.is_reply = false; // 대댓글 여부(true / false)
                    regCommentData.current.prev_top = -1 // 댓글 삭제 후, 저장된 이전 스크롤바 top 값
                }
                $("[id^=txt_Reg_Comment_]").val(""); // 모든 댓글 등록 UI에 입력했던 내용 삭제
                $("[id^=root_emoji_]").hide(); // 모든 이모지 영역 숨김
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CommentListReducer_Result]);

    useEffect(() => {

        if (CommentRegReducer_Result.status === "LOADING") {
            // 댓글 등록 > 통신 중 일 경우
        }
        else if (CommentRegReducer_Result.status === "FAIL") {
            // 댓글 등록 > 통신 실패된 경우

            const message = "댓글 등록 실패, 통신 처리 중 알 수 없는 오류가 발생하였습니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
        }
        else if (CommentRegReducer_Result.status === "COMPLETE") {
            // 댓글 등록 > 통신 성공된 경우

            dispatch(CommentRegActions.setInitStatus()); // 여기 영역이 중복 실행되지 않도록 초기화 실행

            if (CommentRegReducer_Result.n4ErrorCode !== 0) {

                const message = CommentRegReducer_Result.strErrorMessage;
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else if (!CommentRegReducer_Result.isSuccess) {

                const message = "댓글 등록 처리 중 알 수 없는 오류가 발생하였습니다.";
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else {

                const message = "댓글이 등록 되었습니다.";
                setToastMessageState(rawState => ({ ...rawState, isShow: true, message }));

                setBoardInfoState_CommentRegKey(Math.random().toString()); // 댓글등록 UI 리랜더링 요청
                dispatch(asyncReqIsLogin({ logout_req_yn: "N", show_dim: false })); // 로그인 여부 값 가져오기 (로딩바 표시되지 않도록 'show_dim' 값을 'false'로 세팅)

                // 댓글 관련 데이터 갱신
                regCommentData.current.comment_seq = CommentRegReducer_Result.INFO.UBC_COMMENT_SEQ; // 댓글 고유번호
                regCommentData.current.is_reply = CommentRegReducer_Result.INFO.UBC_REF_COMMENT_SEQ === "" ? false : true; // 대댓글 여부(true / false)

                // 신규 댓글 목록 배열에 추가
                dispatch(CommentListActions.addList({
                    UBC_BOARD_SEQ: CommentRegReducer_Result.INFO.UBC_BOARD_SEQ,
                    UBC_COMMENT_SEQ: CommentRegReducer_Result.INFO.UBC_COMMENT_SEQ,
                    UBC_REF_COMMENT_SEQ: CommentRegReducer_Result.INFO.UBC_REF_COMMENT_SEQ,
                    UBC_CONTENT: CommentRegReducer_Result.INFO.UBC_CONTENT,
                    UBC_REG_MEM_UDID: CommentRegReducer_Result.INFO.UBC_REG_MEM_UDID,
                    UBC_REG_DT: CommentRegReducer_Result.INFO.UBC_REG_DT,
                    UMM_NICKNAME: CommentRegReducer_Result.INFO.UMM_NICKNAME
                }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CommentRegReducer_Result]);

    useEffect(() => {

        if (CommentRemoveReducer_Result.status === "LOADING") {
            // 댓글 삭제 > 통신 중 일 경우
        }
        else if (CommentRemoveReducer_Result.status === "FAIL") {
            // 댓글 삭제 > 통신 실패된 경우

            const message = "댓글 삭제 실패, 통신 처리 중 알 수 없는 오류가 발생하였습니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
        }
        else if (CommentRemoveReducer_Result.status === "COMPLETE") {
            // 댓글 삭제 > 통신 성공된 경우

            dispatch(CommentRemoveActions.setInitStatus()); // 여기 영역이 중복 실행되지 않도록 초기화 실행

            if (CommentRemoveReducer_Result.n4ErrorCode !== 0) {

                const message = CommentRemoveReducer_Result.strErrorMessage;
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else if (!CommentRemoveReducer_Result.isSuccess) {

                const message = "댓글 삭제 처리 중 알 수 없는 오류가 발생하였습니다.";
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else {

                const message = "댓글이 삭제 되었습니다.";
                setToastMessageState(rawState => ({ ...rawState, isShow: true, message }));

                // 댓글 관련 데이터 갱신
                regCommentData.current.prev_top = window.scrollY; // 댓글 삭제 후, 저장된 이전 스크롤바 top 값

                // 삭제된 댓글 목록 배열에서 삭제
                dispatch(CommentListActions.removeItem(CommentRemoveReducer_Result.INFO.UBC_COMMENT_SEQ));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CommentRemoveReducer_Result]);

    /**
    * 댓글 목록 가져오기
    * 
    * @param page_no 페이지 번호
    * @returns 
    */
    const renderCommentList = (page_no: number) => {

        const page_size = parseInt(process.env.REACT_APP_COMMENT_PAGE_SIZE as string, 10);
        const curr_page = page_no;
        const board_seq = CommonUtil.getQuerystring("seq", "");
        dispatch(asyncReqCommentList({ page_size, curr_page, board_seq }));
        dispatch(CommentListActions.setCurrPage(curr_page)); // 현재 페이지 번호 저장
    }

    /**
    * 댓글삭제 버튼 클릭 이벤트 
    * 
    * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
    * @param {string} comment_seq 댓글 고유번호
    * @returns {void}
    */
    const hendlerReplyDel = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, comment_seq: string): void => {
        e.preventDefault();

        const reg_udid = MEM_UDID;
        dispatch(asyncReqCommentRemove({ comment_seq, reg_udid }));
    }

    /**
    * 답변등록 버튼 클릭 이벤트 
    * 
    * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
    * @param {string} comment_seq 댓글 고유번호
    * @returns {void}
    */
    const hendlerAnswer = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, comment_seq: string): void => {
        e.preventDefault();

        if (MEM_UDID === "") {
            const message = "로그인 후 이용 가능합니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            return;
        }
        if (comment_seq !== "") {
            $("#txt_Reg_Comment_" + comment_seq).val("");  // 댓글 등록 > 입력했던 내용 제거
            $("#root_emoji_" + comment_seq).hide(); // 이모지 영역 숨김
        }

        setAnswerTargetSeq(state => state = comment_seq);
    }

    /**
    * 페이징 버튼 클릭 이벤트
    * 
    * @param e 이벤트 객체
    * @param page_no 페이지 번호
    * @returns 
    */
    const moveCommentPage = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, page_no: number) => {
        e.preventDefault();

        (window as any).isPageMove = true; // 페이지 이동 알림

        setIsBottomLoading(false); // 바닥 로딩바 숨김 처리
        renderCommentList(page_no);
    }

    /**
    * 댓글목록 페이징 UI 생성
    * 
    * @param totalData 검색된 총 데이터 개수
    * @param dataPerPage 한 페이지 당 최대 표시 개수
    * @param pageCount 페이징 컨트롤 UI 상 최대 페이지 번호 표시 개수
    * @param currentPage 현재 페이지 번호
    * @returns 페이지 컨트롤 jsx 반환
    */
    const createPagingControl = (totalData: number, dataPerPage: number, pageCount: number, currentPage: number) => {

        if (totalData === 0) {
            return "";
        }

        var totalPage = Math.ceil(totalData / dataPerPage);    // 총 페이지 수
        var pageGroup = Math.ceil(currentPage / pageCount);    // 페이지 그룹

        var last = pageGroup * pageCount;    // 화면에 보여질 마지막 페이지 번호
        if (last > totalPage)
            last = totalPage;
        var first = last - (pageCount - 1);    // 화면에 보여질 첫번째 페이지 번호
        if (first < 1) first = 1;

        //var next = last + 1;
        var prev = first - 1;
        var end = Math.floor((totalData / dataPerPage) + ((totalData % dataPerPage === 0) ? 0 : 1));

        var pages = [];
        for (var i = first; i <= last; i++) {
            pages.push(i);
        }

        return (
            <nav className="pg_wrap" style={{ width: "100%" }}>
                <span className="pg" id="span_page_ui">
                    {
                        currentPage !== 1 ?
                            <a href="#none" id="first" onClick={e => moveCommentPage(e, 1)} style={{ marginRight: "10px", textDecoration: "none" }}><i className="fa fa-backward" aria-hidden="true"></i> </a>
                            : ""
                    }
                    {
                        prev > 0 ?
                            <a href="#none" id="prev" onClick={e => moveCommentPage(e, CommentListReducer_Result.currPage - 1)} style={{ marginRight: "10px", textDecoration: "none" }}><i className="fa fa-step-backward" aria-hidden="true"></i> </a>
                            : ""
                    }
                    {
                        pages.map((item, idx) => <a href="#none" key={idx} onClick={e => { item === CommentListReducer_Result.currPage ? e.preventDefault() : moveCommentPage(e, item) }} style={{ textDecoration: "none" }} className={item === CommentListReducer_Result.currPage ? "pg_current" : "pg_page"}>{item}</a>)
                    }
                    {
                        last !== totalPage ?
                            <a href="#none" id="next" onClick={e => moveCommentPage(e, CommentListReducer_Result.currPage + 1)} style={{ marginLeft: "10px", textDecoration: "none" }}><i className="fa fa-step-forward" aria-hidden="true"></i> </a>
                            : ""
                    }
                    {
                        end !== currentPage ?
                            <a href="#none" id="end" onClick={e => moveCommentPage(e, CommentListReducer_Result.n4TotalPage)} style={{ marginLeft: "10px", textDecoration: "none" }}><i className="fa fa-forward" aria-hidden="true"></i> </a>
                            : ""
                    }
                </span>
            </nav>
        )
    }

    if (
        (CommentListReducer_Result.status === "LOADING" || CommentListReducer_Result.status === "FAIL") &&
        isBottomLoading // 바닥 로딩바 표시 처리된 경우
    ) {

        return (
            <p id="p_reply_loading" className="bo_vc_empty">
                <img src="/images/ajax-loader-2.gif" alt="" /><br /><br />댓글 목록을 가져오는 중입니다..
            </p>
        );
    }
    else {

        if (CommentListReducer_Result.LIST.length === 0) {
            return (
                <p id="p_reply_loading" className="bo_vc_empty">
                    등록된 댓글이 없습니다.
                </p>
            );
        }
        else {

            return (
                <div>
                    {
                        CommentListReducer_Result.LIST?.map((item, idx) => {
                            if (item.UBC_COMMENT_SEQ === item.UBC_REF_COMMENT_SEQ) {
                                // 댓글 일 경우

                                return (
                                    <div key={idx}>
                                        <article className="c_5241" id={"comment_root_" + item.UBC_COMMENT_SEQ}>
                                            <div className="cmt_contents">
                                                <div>
                                                    <span className="guest" style={{ float: "left" }}>{item.UMM_NICKNAME}</span>
                                                    <span className="bo_vc_hdinfo" style={{ float: "right", textAlign: "right" }}>{item.UBC_REG_MEM_UDID === MEM_UDID ? <a href="#none" onClick={(e) => hendlerReplyDel(e, item.UBC_COMMENT_SEQ)}><i className="fa fa-times" aria-hidden="true"></i>삭제</a> : ""}&nbsp;<i className="fa fa-clock-o" aria-hidden="true"></i> {item.UBC_REG_DT}</span>
                                                </div>
                                                <p style={{ marginTop: "30px" }}>
                                                    <div dangerouslySetInnerHTML={{ __html: CommonUtil.autoLink(item.UBC_CONTENT, { target: "_blank" }) }}>
                                                        {/* 'DOMPurify.sanitize' 함수를 사용하면, <a>만 남고 <script>는 제거됨 - 터미널에서 'npm install dompurify' 입력해서 설치 필요 */}
                                                    </div>
                                                </p>
                                                <div style={{ marginTop: "20px" }}>
                                                    {
                                                        item.UBC_COMMENT_SEQ === answerTargetSeq
                                                            ? <a id={"answer_btn_" + item.UBC_COMMENT_SEQ} className="guest commment_reg" style={{ padding: "5px", textDecoration: "none", backgroundColor: "#ff762d" }} href="#none" onClick={(e) => hendlerAnswer(e, "")}>답글취소</a>
                                                            : <a id={"answer_btn_" + item.UBC_COMMENT_SEQ} className="guest commment_reg" style={{ padding: "5px", textDecoration: "none" }} href="#none" onClick={(e) => hendlerAnswer(e, item.UBC_COMMENT_SEQ)}>답글등록</a>
                                                    }
                                                </div>
                                                <div id={"answer_ui_" + item.UBC_COMMENT_SEQ}></div>
                                            </div>
                                        </article>
                                        <article className="c_5241" id={"answer_result_" + item.UBC_COMMENT_SEQ} style={{ display: item.UBC_COMMENT_SEQ === answerTargetSeq ? "block" : "none" }}>
                                            <CommentReg comment_seq={item.UBC_COMMENT_SEQ} />
                                        </article>
                                    </div>
                                )
                            }
                            else {
                                // 답글 일 경우

                                return (
                                    <article className="c_5241" key={idx} id={"comment_root_" + item.UBC_COMMENT_SEQ}>
                                        <i className="fa fa-hand-o-right fa-2x" aria-hidden="true" style={{ float: "left", marginTop: "15px" }}></i>
                                        <div className="cmt_contents" style={{ marginLeft: "30px", background: "#f0f0f0", padding: "15px", border: "0px" }}>
                                            <div>
                                                <span className="guest" style={{ float: "left" }}>{item.UMM_NICKNAME}</span>
                                                <span className="bo_vc_hdinfo" style={{ float: "right", textAlign: "right" }}>{(item.UBC_REG_MEM_UDID === MEM_UDID ? <a href="#none" onClick={(e) => hendlerReplyDel(e, item.UBC_COMMENT_SEQ)}><i className="fa fa-times" aria-hidden="true"></i> 삭제</a> : "")}&nbsp;<i className="fa fa-clock-o" aria-hidden="true"></i> {item.UBC_REG_DT}</span>
                                            </div>
                                            <p style={{ marginTop: "30px" }}>
                                                <div dangerouslySetInnerHTML={{ __html: CommonUtil.autoLink(item.UBC_CONTENT, { target: "_blank" }) }}>
                                                    {/* 'DOMPurify.sanitize' 함수를 사용하면, <a>만 남고 <script>는 제거됨 - 터미널에서 'npm install dompurify' 입력해서 설치 필요 */}
                                                </div>
                                            </p>
                                        </div>
                                    </article>
                                )
                            }
                        })
                    }
                    <div style={{ width: "100%", height: "10px", float: "left" }}>&nbsp;</div>

                    {createPagingControl(CommentListReducer_Result.n4TotalCount, parseInt(process.env.REACT_APP_COMMENT_PAGE_SIZE as string, 10), 10, CommentListReducer_Result.currPage)}
                </div>
            )
        }
    }
}

export default CommentList;
